import React from 'react';
import { FadeIn } from './FadeIn';
import { PriceCTA } from './PriceCTA';
import { Lock, CreditCard, Users, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex flex-col justify-center py-24 px-6 overflow-hidden" data-id="element-97">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-terracotta/5 blur-[120px] rounded-full pointer-events-none" data-id="element-98" />

      <div className="max-w-4xl mx-auto w-full relative z-10" data-id="element-99">
        <FadeIn delay={0.1} data-id="element-100">
          <div className="flex flex-wrap items-center justify-center gap-3 mb-10 text-sm tracking-wide text-cream/70 uppercase" data-id="element-101">
            <span className="px-3 py-1 border border-white/10 rounded-full" data-id="element-102">
              📥 PDF Digital — Acceso Inmediato
            </span>
            <span className="px-3 py-1 border border-white/10 rounded-full" data-id="element-103">
              🎯 Nivel: Para quienes sienten que la cabeza no frena
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-104">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-center leading-[1.1] mb-8" data-id="element-105">
            La Ansiedad Es Tu Síntoma,
            <br data-id="element-106" />
            <span className="italic text-terracotta font-light" data-id="element-107">
              No Tu Identidad
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-108">
          <p className="text-lg sm:text-xl md:text-2xl text-center text-cream/80 max-w-3xl mx-auto leading-relaxed mb-12 font-light" data-id="element-109">
            Tu mente bajo control en un fin de semana: el método definitivo para
            desmantelar el caos mental, recuperar la disciplina emocional y
            apagar el piloto automático.{' '}
            <span className="font-medium text-cream" data-id="element-110">
              Sin fármacos. Sin procesos eternos.
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="flex flex-col items-center" data-id="element-111">
          <div className="mb-8 w-full" data-id="element-112">
            <PriceCTA data-id="element-113" />
          </div>

          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-cream/60" data-id="element-114">
            <div className="flex items-center gap-2" data-id="element-115">
              <Lock size={16} className="text-terracotta" data-id="element-116" />
              <span data-id="element-117">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-118">
              <CreditCard size={16} className="text-terracotta" data-id="element-119" />
              <span data-id="element-120">Mercado Pago disponible</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-121">
              <Users size={16} className="text-terracotta" data-id="element-122" />
              <span data-id="element-123">Más de 500 personas ya recuperaron el control</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-124">
              <Star size={16} className="text-terracotta fill-terracotta" data-id="element-125" />
              <span data-id="element-126">4.9/5 de Calificación</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}